export class DashboardDefaults {
    static config = {
        calculatorName: 'individual',
        categoryName: 'vehicle',
        POUNDS_MULTIPLIER: 2204.622622,
        TONNES_MULTIPLIER: 1,
        alternateUnitSymbol: 'mT',
        currentUnitSymbol: 'lbs'
    };
    static mtAvgTotal = {
        slug: 'total',
        name: 'U.S. Average',
        usEmissionAverage: 0
    };
    static totalCategory = {
        slug: 'total',
        name: 'Your Total',
        totalEmissions: 0
    };
    static offsetsProductTitles = {
        individual: 'Individuals',
        business: 'Businesses',
        events: 'Events'
    };
    static categories = {
        individual: {
            vehicle: {
                name: 'Vehicle',
                slug: 'vehicle',
                usEmissionAverage: 0,
                inDollarsPerMonth: 0,
                totalEmissions: 0,
            },
            transit: {
                name: 'Public Transit',
                slug: 'transit',
                usEmissionAverage: 0,
                inDollarsPerMonth: 0,
                totalEmissions: 0
            },
            airTravel: {
                name: 'Air Travel',
                slug: 'travel',
                usEmissionAverage: 0,
                inDollarsPerMonth: 0,
                totalEmissions: 0
            },
            home: {
                name: 'Home Energy',
                slug: 'home',
                usEmissionAverage: 0,
                inDollarsPerMonth: 0,
                totalEmissions: 0
            }
        },
        business: {
            site: {
                name: 'Site',
                slug: 'site',
                inDollarsPerMonth: 0,
                totalEmissions: 0
            },
            fleet: {
                name: 'Fleet',
                slug: 'fleet',
                inDollarsPerMonth: 0,
                totalEmissions: 0
            },
            travel: {
                name: 'Air Travel',
                slug: 'travel',
                inDollarsPerMonth: 0,
                totalEmissions: 0
            },
            commute: {
                name: 'Commute',
                slug: 'commute',
                inDollarsPerMonth: 0,
                totalEmissions: 0
            },
            shipping: {
                name: 'Shipping',
                slug: 'shipping',
                inDollarsPerMonth: 0,
                totalEmissions: 0
            },
            server: {
                name: 'Server',
                slug: 'server',
                inDollarsPerMonth: 0,
                totalEmissions: 0
            }
        },
        events: {
            travel: {
                name: 'Travel',
                slug: 'travel',
                inDollarsPerMonth: 0,
                totalEmissions: 0
            },
            commute: {
                name: 'Commute',
                slug: 'commute',
                usEmissionAverage: 0,
                inDollarsPerMonth: 0,
                totalEmissions: 0
            },
            venue: {
                name: 'Venue',
                slug: 'venue',
                inDollarsPerMonth: 0,
                totalEmissions: 0
            },
            water: {
                name: 'Water',
                slug: 'water',
                inDollarsPerMonth: 0,
                totalEmissions: 0
            },
            meals: {
                name: 'Meals',
                slug: 'meals',
                inDollarsPerMonth: 0,
                totalEmissions: 0
            }
        }
    };
    static usAverageServerKeyMap = {
        mtAvgVehicle: 'vehicle',
        mtPublicTransit: 'transit',
        mtAirTravel: 'airTravel',
        mtHomeEnergy: 'home'
    };

    static setAverageCategoryEmission(emissions): void {
        let map = this.usAverageServerKeyMap;
        let categories = this.categories.individual;
        this.mtAvgTotal['usEmissionAverage'] = emissions.mtAvgTotal;

        for (let key in map) {
            if (map.hasOwnProperty(key)) {
                categories[map[key]].usEmissionAverage = emissions[key];
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/dashboard/dashboardDefaults.ts